import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Button,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
} from '@chakra-ui/react'
import { useRef } from 'react'
import { PatternForm } from './pattern-form'
import { METAForm } from './metadado-form'
import { LLMForm } from './llm-form'
import { PackageSearch } from 'lucide-react'

export function PostProcessmentDrawer({ questionId }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const btnRef = useRef()

  return (
    <>
      <Button ref={btnRef} onClick={onOpen}>
        <PackageSearch />
      </Button>
      <Drawer
        isOpen={isOpen}
        placement='right'
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent maxWidth={'400px'}>
          <DrawerCloseButton />
          <DrawerHeader>Pós-processamento</DrawerHeader>

          <DrawerBody>
          <Tabs size='md' variant='enclosed'>
            <TabList>
              <Tab>Padrão</Tab>
              <Tab>LLM</Tab>
              <Tab>Metadados</Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <PatternForm questionId={questionId} onClose={onClose} />
              </TabPanel>
              <TabPanel>
                <LLMForm questionId={questionId} onClose={onClose} />
              </TabPanel>
              <TabPanel>
                <METAForm questionId={questionId} onClose={onClose} />
              </TabPanel>
            </TabPanels>
          </Tabs>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  )
}